<template>
	<div class="layout-component">
		<Head class="head-wrapper"></Head>
		<Main class="main-wrapper"></Main>
		<Foot class="foot-wrapper"></Foot>
		<Tool class="tool-wrapper"></Tool>
	</div>
</template>

<script>
import Head from '@/layout/Head/Head.vue';
import Main from '@/layout/Main/Main.vue';
import Foot from '@/layout/Foot/Foot.vue';
import Tool from '@/layout/Tool/Tool.vue';
export default {
	name: 'Layout',
	components: {
		Head,
		Main,
		Foot,
		Tool
	},
	data() {
		return {
			
		};
	}
};
</script>

<style lang="scss" scoped>
// .app-component {
// 	.foot-wrapper {
// 		display: none;
// 	}
// 	.tool-wrapper {
// 		display: none;
// 	}
// }

.layout-component {
	flex: 1;
	display: flex;
	flex-direction: column;
	.head-wrapper {
	}
	.main-wrapper {
		flex: 1;
		display: flex;
		flex-direction: column;
	}
	.foot-wrapper {
		margin-top: auto;
	}
	.tool-wrapper {
	}
}
</style>
